
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M33 18c0 8.285-6.716 15-15 15-8.284 0-15-6.715-15-15C3 9.716 9.716 3 18 3c8.284 0 15 6.716 15 15zm-3 0c0 6.628-5.373 12-12 12S6 24.628 6 18c0-6.627 5.373-12 12-12a11.97 11.97 0 018.913 3.966L16.5 20.379l-4.19-4.19a1.5 1.5 0 00-2.12 2.122l4.189 4.19a3 3 0 004.242 0l10.031-10.032A11.948 11.948 0 0130 18z","fill":"currentColor"}})])
          )
        }
      }
    